import React from 'react';
import { colors } from '../constants';

import { unselectedStrokeColor, unselectedFillColor } from './icon_helpers';

const RatingStrongNoIcon = ({
  width = 20,
  height = 20,
  unselected = false,
}) => {
  const strokeColor = unselected ? unselectedStrokeColor : colors.darkRed;
  const fillColor = unselected ? unselectedFillColor : colors.lightRed;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height}>
      <g fill="none">
        <path
          fill={strokeColor}
          d="M13.529 1.71H6.463L1.708 6.54v6.873l4.758 4.872h7.06l4.757-4.872V6.541L13.53 1.71zM14.14.248l5.605 5.694v8.067l-5.605 5.739H5.85L.246 14.009V5.942L5.85.248h8.291z"
        />
        <path
          fill={fillColor}
          d="M13.529 1.71H6.463L1.708 6.541v6.872l4.758 4.872h7.059l4.758-4.872V6.541z"
        />
        <path
          fill={strokeColor}
          d="M10.097 9.065l3.484-3.484a.731.731 0 0 1 1.035 1.034l-3.485 3.484 3.485 3.485a.731.731 0 1 1-1.035 1.034l-3.484-3.485-3.484 3.485a.731.731 0 0 1-1.034-1.034l3.484-3.485-3.484-3.484a.731.731 0 1 1 1.034-1.034l3.484 3.484z"
        />
      </g>
    </svg>
  );
};

export default RatingStrongNoIcon;
